"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Palette {
    constructor(colors) {
        this.enabled = [];
        this.colors = colors;
        colors.forEach((color, index) => this.enabled.push(index));
    }
}
exports.default = Palette;
//# sourceMappingURL=Palette.js.map